'use strict';

const ScrollUtil = {
	scrollToId: function(id) {
		this.scrollToSelector(`#${id}`);
	},

	scrollToSelector: function(selector) {
        const element = document.querySelector(selector);
        if (element) {
        	if (typeof element.scrollIntoView === 'function') {
        		element.scrollIntoView();
        	}
        	else {
        		console.warn(`ScrollUtil.scrollToSelector: Element.scrollIntoView() not supported.`);
        	}
        }
        else {
        	console.warn(`ScrollUtil.scrollToSelector: Element with selector "${selector}" not found.`);
        }
	},

    scrollToUsingHash: function() {
        const decodedHashString = window.decodeURIComponent(window.location.hash);
        const hashParts = decodedHashString.split('#');
        if (hashParts.length >= 2) {
            const hash = hashParts.slice(-1)[0];
            ScrollUtil.scrollToSelector(`a[name="#${hash}"]`);
        }
        else {
            window.scrollTo(0, 0);
        }
    }
};

module.exports = ScrollUtil;
